import { render, staticRenderFns } from "./create_large.vue?vue&type=template&id=60bd9340"
import script from "./create_large.vue?vue&type=script&lang=js"
export * from "./create_large.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports